module.exports = __webpack_public_path__ + "static/media/icon-change.d48d992b.svg";